<template lang="pug">
.h-full
  .business-unit-switcher
    .business-unit-title-wrapper
      BriqButton.mr-2.open-slide-in-button(
        @click="openTreeView"
        variant="secondary"
        small
        v-if="this.availableBusinessUnits.length > 1"
        )
        span.mr-2 {{ businessUnitName }}
        BriqIcon(name="icon-list-icon" :customStyle="listIconStyle")
      span.business-unit-name(v-else) {{ businessUnitName }}
    SlideInPanel(:isOpen="treeviewOpen" @close="treeviewOpen = false" v-if="this.availableBusinessUnits.length > 1")
      .business-unit-select-panel.p-XS.type-standard
        .close-button-wrapper.mb-2
          BriqButton(@click="closeTreeview" small variant="dark") Close
        BriqInput.mb-XS(
          v-model="search"
          label="Search Business Unit"
          ref="searchTextInput"
          hide-optional-marker
          )
        BriqTreeView(
          :items="treeViewItems"
          :query="search"
          :itemsWithExpansionState="itemsWithExpansionState"
          )
          template(slot="label" slot-scope="{ item }")
            button.select-bu-button(type="button" @click="selectBusinessUnit(item)") {{ item.name }}
</template>

<script>
import { map } from 'ramda'
import SlideInPanel from '@v/components-global/layout/SlideInPanel.vue'
import SitemapLink from '@v/debug/sitemap/SitemapLink.vue'
import BriqTreeView from './BriqTreeView.vue'
import { toTreeViewModel } from './toTreeViewModel.js'

export default {
  name: 'BusinessUnitSwitcherModal',
  components: { SlideInPanel, SitemapLink, BriqTreeView },
  props: {
    selectedBusinessUnit: { type: String, required: true },
    availableBusinessUnits: { type: Array, required: true },
  },
  data() {
    return {
      search: null,
      caseSensitive: false,
      treeviewOpen: false,
      allowedLengthOfBusinessUnitName: 30,
      itemsWithExpansionState: null,
    }
  },
  computed: {
    businessUnitName() {
      return this.selectedBusinessUnit.length > this.allowedLengthOfBusinessUnitName
        ? `${this.selectedBusinessUnit.substring(0, this.allowedLengthOfBusinessUnitName)}...`
        : this.selectedBusinessUnit
    },
    isBusinessUnitNameLarge() {
      return this.selectedBusinessUnit.length > this.allowedLengthOfBusinessUnitName
    },
    cursorPointer() {
      return this.availableBusinessUnits.length > 1 ? 'cursor-pointer' : ''
    },
    treeViewItems() {
      return toTreeViewModel(this.availableBusinessUnits)
    },
    listIconStyle() {
      return {
        opacit: '0.5',
        fontSize: '24px',
        marginTop: '6px',
        marginLeft: '4px',
      }
    },
  },
  methods: {
    openTreeView() {
      this.treeviewOpen = this.availableBusinessUnits.length > 1 ? true : false
      setTimeout(
        function() {
          this.$nextTick(() => {
            this.$document.querySelector('.business-unit-select-panel input').focus()
          })
        }.bind(this),
        300,
      )
    },
    async selectBusinessUnit(item) {
      this.$document.body.style.cursor = 'progress'
      try {
        await this.$apiClient.post(`auth/switch-business-unit/${item.key}`)
        this.$window.location.reload()
      } catch (e) {
        this.$notifyError('Something went wrong')
        this.$logError(e)
      }
    },
    closeTreeview() {
      this.treeviewOpen = false
      setTimeout(() => (this.search = ''), 300)
    },
  },
  beforeMount() {
    this.itemsWithExpansionState = map(bu => {
      return {
        name: bu.Name,
        key: bu.Key,
        expanded: true,
      }
    })(this.availableBusinessUnits)
  },
}
</script>

<style scoped lang="stylus">
.business-unit-switcher
  text-align left
  height 100%

.business-unit-title-wrapper
  display flex
  height 100%
  justify-content flex-end
  align-items center

  .business-unit-name
    display flex
    align-items center
    height 100%

  .open-slide-in-button
    height 40px
    display flex
    align-items center
    justify-content center

.business-unit-select-panel
  width 500px

  .close-button-wrapper
    display flex
    justify-content flex-end

.select-bu-button
  width 100%
  text-align left
</style>
